import {Component} from '@angular/core';

@Component({
  selector: 'app-modal-about-us',
  templateUrl: './modal-about-us.component.html',
  styleUrls: ['./modal-about-us.component.scss']
})
export class ModalAboutUsComponent {
  public isModalAboutUsShow: boolean = false;
  public isDarkBackground: boolean = false;

  openModalAboutUsShow() {
    this.isModalAboutUsShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalAboutUsShow = false
    this.isDarkBackground = false;
  }
}
